import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import SeoArticles from './components/SeoArticles';
import AboutSection from './components/AboutSection';
import FeatureGrid from './components/FeatureGrid';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main>
      <Navbar />
      <Hero />
      <CategoryGrid />
      <SeoArticles />
      <AboutSection />
      <FeatureGrid />
      <CtaSection />
      <Footer />
    </main>
  );
}